import React from 'react'
import styles from './index.module.less'
import { BackTop } from 'antd'
const data = [
  { id: 1, img: 'https://hyhzpharmax-1316759422.cos.ap-shanghai.myqcloud.com/assets/phamax/lb-37.png', cont: '企业级产品功能的增长与用户系统角色的演变相生相伴。设计者应为自己创造的产品负责，提升功能、价值的可发现性。用发展的眼光做设计，充分考虑人、机两端的共同生长。' },
  { id: 2, img: 'https://hyhzpharmax-1316759422.cos.ap-shanghai.myqcloud.com/assets/phamax/lb-37.png', cont: '企业级产品功能的增长与用户系统角色的演变相生相伴。设计者应为自己创造的产品负责，提升功能、价值的可发现性。用发展的眼光做设计，充分考虑人、机两端的共同生长。' },
  { id: 3, img: 'https://hyhzpharmax-1316759422.cos.ap-shanghai.myqcloud.com/assets/phamax/lb-37.png', cont: '企业级产品功能的增长与用户系统角色的演变相生相伴。设计者应为自己创造的产品负责，提升功能、价值的可发现性。用发展的眼光做设计，充分考虑人、机两端的共同生长。' },
]
export default function Vendors() {
  return (
    <div style={{ backgroundColor: '#F4F9FE' }}>
      <div className={styles.cont}>
        <BackTop />
        <span className={styles.big_title}>赞助商</span>
        {
          data.map(i => (
            <div className={styles.item} key={i.id}>
              <div className={styles.left}>
                <img src={i.img} alt="" />
              </div>
              <div className={styles.right}>
                <p>{i.cont}</p>
              </div>
            </div>
          ))
        }
      </div>
    </div>
  )
}
